import { ImageDefinition } from '@/models/image-definition';
import { Journey } from '@/models/journey';
import { PathSegment } from '@/models/path-segment';
import { Option } from './option';
import { SimplePathSegment } from './simple-path-segment';

export class PackagePathSegment extends SimplePathSegment {
   public readonly options: Array<Option> = [];
   public readonly recommended: boolean;

   constructor(
      title: string,
      alias: string,
      price: number,
      showPrice: boolean,
      isCostExternal: boolean,
      recommended: boolean,
      description?: string,
      image?: ImageDefinition,
      icon?: string,
      options?: Array<Option>,
      dataObject?: Journey,
      children?: Array<PathSegment>) {
      super(
         'PackagePathSegment', title, alias, price, showPrice, isCostExternal, description, image, icon, dataObject,
         children);
      this.options = options ?? [];
      this.recommended = recommended;
   }
}
